import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setVariantsQuantity } from '../../actions/orders';
import {
  customSelectStyles, interpolatePriceToTemplate, isDefaultTitle, priceFormat,
} from '../../utilities/helperUtility';
import Select from '../../components/Common/Select';
import SwatchButtonGroups from './SwatchButtonGroups';
import { stringToBoolean } from '../../utilities/conversionUtility';

class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOptions: {},
    };

    this.handleProductOptionClick = this.handleProductOptionClick.bind(this);
  }

  componentDidMount() {
    const { variants, variantSelected, onTrigger } = this.props;
    const currentVariant = variants.find((variant) => variant.external_id === variantSelected);
    if (onTrigger) {
      onTrigger('variantChanged', currentVariant);
    }
  }

  componentDidUpdate(prevProps) {
    const { options, variantSelected, variants } = this.props;

    if (variantSelected !== prevProps.variantSelected) {
      const currentVariant = variants.find((variant) => variant.external_id === variantSelected);
      if (currentVariant) {
        const newSelectedOptions = {};
        options.map((o, index) => {
          newSelectedOptions[o.name] = currentVariant.options[index];
        });
        this.setState({ selectedOptions: newSelectedOptions });
      }
    }
  }

  onVariantsChange(id) {
    const { onTrigger, onSetVariantsQuantity, variants, setting } = this.props;
    const currentVariant = variants.find((variant) => variant.external_id === id);
    const externalId = currentVariant ? currentVariant.external_id : null;

    // Respect minimum quantity setting when changing variants
    // Only apply minimum quantity if quantity chooser is enabled
    const showQuantityChooser = stringToBoolean(setting.show_quantity_chooser);
    const minimumQuantity = showQuantityChooser && stringToBoolean(setting.set_minimum_quantity)
      ? setting.minimum_quantity
      : 1;
    const quantity = minimumQuantity || 1;

    onSetVariantsQuantity(`${externalId}_quantity`, quantity, {
      singleVariant: true,
    });
    if (onTrigger) {
      onTrigger('variantChanged', currentVariant);
    }
  }

  variantOptions() {
    const { variants, setting } = this.props;
    const showPrice = setting && setting.hasOwnProperty('show_price') ? stringToBoolean(setting.show_price) : true;

    return variants.map(({ external_id, title, price }) => ({
      label: this.buildLabel(title, showPrice ? price : null),
      value: external_id,
    }));
  }

  buildLabel(title, price) {
    if (!price) return title;
    let label = `${title}`;
    if (price) label += ` ${interpolatePriceToTemplate(priceFormat(this.props), price)}`;
    const div = document.createElement('div');
    div.innerHTML = label;
    return div.textContent || div.innerText || '';
  }

  handleProductOptionClick(option, value) {
    const { selectedOptions } = this.state;
    const { options, setting, variants } = this.props;
    if (!value) value = options.find((x) => x.name === option).values[0];
    if (selectedOptions[option] === value) return;
    selectedOptions[option] = value;
    const variant = variants.find((x) => JSON.stringify(x.options) === JSON.stringify(Object.values(selectedOptions)));
    if (!stringToBoolean(setting.test_flow)) this.onVariantsChange(variant ? variant.external_id : null);
  }

  renderSelect() {
    const {
      bodyStyle,
      durations,
      isDisabled,
      labelClass,
      options,
      selectStyles,
      setting,
      variantSelected,
    } = this.props;
    const optionsNames = options ? options.map((o) => o.name) : [];

    if ( // Hide duration variant
      stringToBoolean(setting.hide_choosing_duration)
      && options.length === 1
      && durations
      && options[0].name === durations.option
      && durations.option_durations.length
    ) {
      return null;
    }

    return (
      <>
        <h4 className={`${labelClass || ''} titles`} style={bodyStyle}>
          {optionsNames.join(' / ')}
        </h4>
        <Select
          placeholder="Select Variant ..."
          name="variants"
          styles={selectStyles}
          value={variantSelected}
          options={this.variantOptions()}
          isDisabled={isDisabled}
          isClearable={false}
          isSearchable={false}
          onChange={(x) => this.onVariantsChange(x)}
        />
      </>
    );
  }

  renderSwatches() {
    const { selectedOptions } = this.state;
    const {
      durations, bodyStyle, hoverStyles, isDisabled, options, swatchesStyles, optionsStyles, setting,
    } = this.props;

    const styles = {
      optionsStyle: {
        color: swatchesStyles?.active?.color || bodyStyle.color,
        backgroundColor: swatchesStyles?.active?.backgroundColor || optionsStyles.backgroundColor,
        inactive: {
          color: swatchesStyles?.inactive?.color || hoverStyles?.color,
          backgroundColor: swatchesStyles?.inactive?.backgroundColor || optionsStyles.backgroundColor,
        },
      },
    };

    return (
      <SwatchButtonGroups
        isDisabled={isDisabled}
        defaultOptions={Object.values(selectedOptions)}
        durations={durations}
        options={options}
        setting={setting}
        styles={styles}
        onActiveCallback={this.handleProductOptionClick}
      />
    );
  }

  render() {
    const { bookingToken, className, setting, variants } = this.props;
    const disbleVariantDropdown = variants.every((v) => isDefaultTitle(v.title)) || bookingToken;
    const useSwatches = stringToBoolean(setting.use_swatches);

    if (disbleVariantDropdown) return null;

    return (
      <div className={`${className || ''} variant-select`} data-testid="variant-select">
        { useSwatches ? this.renderSwatches() : this.renderSelect() }
      </div>
    );
  }
}

export default connect(
  ({
    product, order, settings: { bookingToken, moneyFormats = {}, style = {}, setting = {} },
  }) => ({
    bookingToken,
    variants: product.data.variants,
    options: product.data.options,
    durations: product.data.durations,
    variantSelected: order.variantSelected,
    setting,
    moneyFormats,
    swatchesStyles: style.swatch,
    optionsStyles: style.button,
    selectStyles: customSelectStyles(style.select),
    bodyStyle: style.body,
    hoverStyles: style.datepicker?.selector?.hover,
    style,
    onTrigger: window.xprops ? window.xprops.onTrigger : null,
  }),
  (dispatch) => ({
    onSetVariantsQuantity: (a, b, c) => dispatch(setVariantsQuantity(a, b, c)),
  }),
)(Index);
